/**
 * Export loadData calls from ducks modules of different containers
 */
import {
  loadData as AuthenticationPageLoader,
  loadData,
} from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { loadData as LandingPageMerchantLoader } from './LandingPage/LandingPageMerchant.duck';
import { loadData as MerchantOnboardingPageLoader } from './MerchantOnboardingPage/MerchantOnboardingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as ViewListingPageLoader } from './ViewListing/ViewListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as PrivacyPolicyArabicPageLoader } from './PrivacyPolicyArabicPage/PrivacyPolicyArabicPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import { loadData as CartPageLoader } from './CartPage/CartPage.duck';
import { loadData as DealsPageLoader } from './DealsPage/DealsPage.duck';
import { loadData as OrderPageLoader } from './OrderPage/OrderPage.duck';
import { loadData as CalendarPageLoader } from './CalenderPage/CalendarPage.duck';
import { loadData as BookingPageLoader } from './BookingPage/BookingPage.duck';
import { loadData as NotificationPageLoader } from './NotificationPage/NotificationPage.duck';
import { loadData as NotificationPageV2Loader } from './NotificationPageV2/NotificationPageV2.duck';
import { loadData as SendBuzzPageLoader } from './SendBuzzPage/SendBuzzPage.duck';
import { loadData as OrderCompletePageLoader } from './OrderCompletePage/OrderCompletePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as InterestPageLoader } from './InterestPage/InterestPage.duck';
import { loadData as PaymentStatusPageLoader } from './PaymentStatusPage/PaymentStatus.duck';
import { loadData as ValidationPageLoader } from './ValidationPage/ValidationPage.duck';
import { loadData as WishlistPageLoader } from './WishlistPage/WishlistPage.duck';
import { loadData as ProfileSettingsPageLoader } from './ProfileSettingsPage/ProfileSettingsPage.duck';
import { loadData as ViewBusinessPageLoader } from './ViewBusinessPage/ViewBusinessPage.duck';
import { loadData as WhatsappTransactionsPage } from './WhatsappTransactionsPage/WhatsappTransactionsPage.duck';
import { loadData as ContactUsPageLoader } from './ContactUsPage/ContactUsPage.duck';
import { loadData as CustomerDetailsPageLoader } from './CustomerDetailsPage/CustomerDetailsPage.duck';
import { loadData as MerchantDetailsPageLoader } from './MerchantDetailsPage/MerchantDetailsPage.duck';
import { loadData as MerchantFlyerPageLoader } from './MerchantFlyerPage/MerchantFlyerPage.duck';
import { loadData as BookingGuidePageLoader } from './BookingGuidePage/BookingGuidePage.duck';
import { loadData as EditAdsPageLoader } from './EditAdsPage/EditAdsPage.duck';
import { loadData as PreviewAdsPageLoader } from './PreviewAdsPage/PreviewAdsPage.duck';
import { loadData as PromotionPaymentPageLoader } from './PromotionsPaymentPage/PromotionPaymentPage.duck';
import { loadData as MerchantWalletPageLoader } from './MerchantWalletPage/MerchantWalletPage.duck';
import { loadData as StockImagesPageLoader } from './StockImagesPage/StockImagesPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    PaymentStatusPage: {
      loadData: PaymentStatusPageLoader,
    },
    OrderPage: {
      loadData: OrderPageLoader,
    },
    SendBuzzPage: {
      loadData: SendBuzzPageLoader,
    },
    InterestPage: {
      loadData: InterestPageLoader,
    },
    NotificationPage: {
      loadData: NotificationPageLoader,
    },
    NotificationPageV2: {
      loadData: NotificationPageV2Loader,
    },
    CalendarPage: {
      loadData: CalendarPageLoader,
    },
    BookingPage: {
      loadData: BookingPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    LandingPageMerchant: {
      loadData: LandingPageMerchantLoader,
    },
    MerchantOnboardingPage: {
      loadData: MerchantOnboardingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    DealsPage: {
      loadData: DealsPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    PrivacyPolicyArabicPage: {
      loadData: PrivacyPolicyArabicPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    ViewListingsPage: {
      loadData: ViewListingPageLoader,
    },
    CartPage: {
      loadData: CartPageLoader,
    },
    OrderCompletePage: {
      loadData: OrderCompletePageLoader,
    },
    ValidationPage: {
      loadData: ValidationPageLoader,
    },
    WishlistPage: {
      loadData: WishlistPageLoader,
    },
    ProfileSettingsPage: {
      loadData: ProfileSettingsPageLoader,
    },
    ViewBusinessPage: {
      loadData: ViewBusinessPageLoader,
    },
    WhatsappTransactionsPage: {
      loadData: WhatsappTransactionsPage,
    },
    ContactUsPage: {
      loadData: ContactUsPageLoader,
    },
    CustomerDetailsPage: {
      loadData: CustomerDetailsPageLoader,
    },
    MerchantDetailsPage: {
      loadData: MerchantDetailsPageLoader,
    },
    MerchantFlyerPage: {
      loadData: MerchantFlyerPageLoader,
    },
    BookingGuidePage: {
      loadData: BookingGuidePageLoader,
    },
    EditAdsPage: {
      loadData: EditAdsPageLoader,
    },
    PreviewAdsPage: {
      loadData: PreviewAdsPageLoader,
    },
    PromotionPaymentPage: {
      loadData: PromotionPaymentPageLoader,
    },
    MerchantWalletPage: {
      loadData: MerchantWalletPageLoader,
    },
    StockImagesPage: {
      loadData: StockImagesPageLoader,
    },
  };
};

export default getPageDataLoadingAPI;
